import * as React from 'react';
import '@progress/kendo-theme-bootstrap/dist/all.css';
import { createStyles, makeStyles } from '@material-ui/core';
import { Dispatch } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { CategoryCountRequest } from '../../Interfaces/Assets/CategoryCountRequest';
import { getCurrentIssuesForCategory } from '../../store/Devices/AssetStatesActions';
import { GetString } from '../StringResourceManager';
import { ASSET } from '../../utils/constants';
import DynamicComboBox from '../DynamicComboBox';

const useStyles = makeStyles(() =>
  createStyles({
    statusCategoryInput: { width: '250px', minWidth: '5%' },
    statusNameInput: { width: '250px', minWidth: '5%', marginLeft: 10 },
    statusValueTextInput: {
      marginLeft: 10,
    },
  })
);

export const CustomFilterCurrentIssues = (props: any) => {
  const classes = useStyles();
  const dispatch: Dispatch<any> = useDispatch();

  const currentIssueCategories: string[] = useSelector(
    (state: ApplicationState) =>
      state.assetStatusesReducer.currentIssueCategories
  );

  const currentIssueValues: Map<CategoryCountRequest, string[]> = useSelector(
    (state: ApplicationState) => state.assetStatusesReducer.currentIssueValues
  );

  const isFetchingCurrentIssueCategories: boolean = useSelector(
    (state: ApplicationState) =>
      state.assetStatusesReducer.isFetchingCurrentIssueCategories
  );

  const isFetchingCurrentIssueValues: boolean = useSelector(
    (state: ApplicationState) =>
      state.assetStatusesReducer.isFetchingCurrentIssueValues
  );

  const onChangeCurrentIssueCategory = (event: any) => {
    processFetchCategoryCounts(event.target.value);

    props.onFilterChange.call(undefined, {
      nextFilter: {
        ...props.filter,
        value: {
          Category: event.target.value,
          Name: ASSET.CURRENT_ISSUE,
          Value: undefined,
        },
      },
    });
  };

  const processFetchCategoryCounts = (category: string) => {
    let categoryCountRequest: CategoryCountRequest = {
      Category: category,
      Name: ASSET.CURRENT_ISSUE,
    };

    let valueExist: boolean = false;
    currentIssueValues.forEach(function (value: any, key: any, map: any) {
      if (JSON.stringify(key) == JSON.stringify(categoryCountRequest)) {
        valueExist = true;
      }
    });

    if (!valueExist) {
      getCurrentIssuesForCategory(dispatch, categoryCountRequest);
    }
  };

  const onChangeCurrentIssueValue = (event: any) => {
    props.onFilterChange.call(undefined, {
      nextFilter: {
        ...props.filter,
        value: {
          Category: props.filter.value?.Category ?? '',
          Name: ASSET.CURRENT_ISSUE,
          Value: event.target.value,
        },
      },
    });
  };

  const getCurrentIssueData = (category: string, name: string) => {
    let categoryCountRequest: CategoryCountRequest = {
      Category: category,
      Name: name,
    };

    var values: any = [];
    currentIssueValues.forEach(function (value: any, key: any, map: any) {
      if (
        key.Category == categoryCountRequest.Category &&
        key.Name == categoryCountRequest.Name
      ) {
        values = value;
      }
    });

    return values;
  };

  return (
    <React.Fragment>
      <DynamicComboBox
        className={classes.statusCategoryInput}
        onChange={onChangeCurrentIssueCategory}
        data={currentIssueCategories?.slice(1)}
        value={props.filter?.value?.Category ?? ''}
        placeholder={GetString('CATEGORY_PLACEHOLDER')}
        loading={isFetchingCurrentIssueCategories}
      />
      <DynamicComboBox
        className={classes.statusValueTextInput}
        placeholder={GetString('VALUE_PLACEHOLDER')}
        onChange={onChangeCurrentIssueValue}
        data={getCurrentIssueData(
          props.filter?.value?.Category,
          props.filter?.value?.Name
        )}
        value={props.filter?.value?.Value ?? ''}
        disabled={!props.filter?.value?.Name}
        loading={isFetchingCurrentIssueValues}
      />
    </React.Fragment>
  );
};
